import React from 'react';
import { Text } from "../../Typography";

var TooltipItem = function TooltipItem(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "text"
  }, label);
};

export default TooltipItem;